import Oidc from 'oidc-client';
import GetEnv from "../utils/env";
import api from "../config/api";

//TODO Change the URL according to the site the user is visiting (Khaosod (classifieds/property) or Sanook (classifieds/property))
const getUrl = window.location;
const baseUrl = getUrl.protocol + "//" + getUrl.host;

var mgr = async () => {
    let configs = null;
    let configsString = localStorage.getItem('authConfigs-v2');
    if(!configsString) {
        var result = await api.get('/site-configs/auth-config');
        if (result.status === 200) {
            localStorage.setItem('authConfigs-v2', JSON.stringify(result.data.data.configs));
            configs = result.data.data.configs;
        }
    }
    else {
        configs = JSON.parse(configsString); 
    }
    if(configs) {
        let postLogoutUrl = configs.post_logout_url.replace('[BASE_URL]', baseUrl);
        return new Oidc.UserManager({
            authority: configs.auth_server,
            client_id: configs.client_id,
            redirect_uri: `${baseUrl}/th/callback`,
            response_type: 'code',
            scope: configs.scopes,
            post_logout_redirect_uri: postLogoutUrl,
            automaticSilentRenew: true,
            silent_redirect_uri: `${baseUrl}/static/silent-renew.html`,
            accessTokenExpiringNotificationTime: 60,
            userStore: new Oidc.WebStorageStateStore({ store: window.localStorage }),
            acr_values: configs.idp ? `idp:${configs.idp}` : null
        });
    }
}

export default mgr;